import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../component/baseURL";
import { useTranslation } from 'react-i18next';

export default function Catagory() {
    const [search, setSearch] = useState("");
    const [partnerList, setPartnerList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const location = useLocation();
    const { partner_id, category } = location.state || {};
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        fetchPartnerList(category);
    }, []);

    useEffect(() => {
        const filtered = partnerList.filter(partner =>
            partner.company_name.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredList(filtered);
    }, [search, partnerList]);

    const fetchPartnerList = async (category) => {
        let formdata = new FormData();
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        formdata.append("category", category);

        try {
            const response = await fetch(baseURL.URL + '/consumer_end/fetch_pertner_list', {
                method: 'POST',
                body: formdata
            });
            const responseJson = await response.json();
            console.log('PARTNER LIST API RESPONSE-------------------------');
            console.log(responseJson);

            if (responseJson.server.result_code === 200) {
                setPartnerList(responseJson.response);
                setFilteredList(responseJson.response);
                // Handle successful response
                console.log(responseJson.response);
            } else {
                console.error('Error:', responseJson.server.message || "Something went wrong!");
            }
        } catch (error) {
            console.error('Error fetching partner list:', error);
        }
    };

    const handleCardClick = (item) => {
        navigate("/catagory-details", {
            state: {
                partner_id: item.user_id,
                category: category
            }
        });
    };

    return (
        <div className="catagory-wrapper">
            <div className="container">
                <div className="title-holder flex justify-between items-center">
                    <h2 className="page-title" data-aos="zoom-in">{category == 'Supplier' ? t('marketplace') : category + ' ' + t('list')}</h2>
                    <div className="search-box" data-aos="fade-left">
                        <input
                            type="text"
                            placeholder={t('searchWithCompanyName')}
                            value={search}
                            onChange={e => setSearch(e.target.value)}

                        />
                        <span className="search-icon">
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div className="partner-list-holder col-md-12 px-4">
                    <div className="row">
                        {filteredList.length > 0 ? (
                            filteredList.map(item => (
                                <div
                                    key={item.id}
                                    className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
                                    data-aos="zoom-in"
                                    onClick={() => handleCardClick(item)}
                                >
                                    <div className="partner-list-items">
                                        <figure>
                                            <img
                                                src={item.company_image || 'http://www.plannbuild.com/upload/user.jpg'}
                                                alt={item.company_name}
                                            />
                                        </figure>
                                        <div className="partner-list-item-title">
                                            {item.company_name}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center py-5" data-aos="fade-up">
                                <h3 className="text-muted">{t('noResultFound')}</h3>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
